import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HomeComponent } from './home.component';
import { DialogLogin } from './dialog-component/login/dialog-login.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { DialogQueue } from './dialog-component/queue/dialog-queue.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppointmentsComponent } from './appointments/appointments.component';
import { DetailComponent } from './appointments/detail/detail.component';
import { DialogNewTicket } from './dialog-component/new-ticket/dialog-new-ticket.component';

const routes = [
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'appointments',
        component: AppointmentsComponent
    }
];


@NgModule({
    declarations: [
        HomeComponent,
        AppointmentsComponent,
        DialogLogin,
        DialogNewTicket,
        DialogQueue,
        DetailComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        FuseSharedModule,
        TranslateModule,
        MatSnackBarModule
    ],
    exports: [
        HomeComponent
    ]
})

export class HomeModule {
}
